import { api } from "../client";

export const getDailyUtilization = (params) => {
  const { date, floorName, excludeDepartments, filterZones } = params;

  const queryParams = new URLSearchParams();
  queryParams.append("date", date);

  if (floorName && floorName !== "all") {
    queryParams.append("floorName", floorName);
  }

  if (excludeDepartments && excludeDepartments.length > 0) {
    queryParams.append("excludeDepartments", excludeDepartments.join(","));
  }

  if (filterZones && filterZones.length === 1) {
    queryParams.append("filterZones", filterZones.join(","));
  }

  return api.get(`/api/utilization/daily?${queryParams}`);
};
